import dayjs from 'dayjs';

export const getPreviousCalendarMonth = (): Date => {
  return dayjs().subtract(1, 'month').startOf('month').toDate();
};
